// 说明书API
import request from '@/utils/request'
/**
 *说明书分页
 * @param data
 * @returns {*}
 */
export function manualPage(params,data) {
    return request({
        url: '/manual/page',
        method: 'post',
        data,
        params
    })
}
/**
 * 编辑说明书
 * @param data
 * @returns {*}
 */
export function manualEdit(data) {
    return request({
        url: '/manual',
        method: 'put',
        data
    })
}
/**
 * 上传说明书
 * @param data
 * @returns {*}
 */
export function manualAdd( data ) {
    return request({
        url: '/manual',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
